export default "/images/vendor/flag-icon-css/flags/4x3/il.svg?4c70e23214e9da6a56eb525f6a31a5c8";